module.exports = __webpack_public_path__ + "Tinebase/js/ace-theme-tomorrow_night_bright-FAT.js";